define([
    "./nodeCommandsModule",
    "./nodeCommandViewRoute",
    "./nodeCommandCalculateToll",
    "./calculateExternalFreightCommand",
    "./nodeCommandCancelTrips",
    "./nodeCommandOptimize",
    "./nodeCommandOptimizeRestrictions",
    "./nodeCommandFinalizeTrip",
    "./nodeCommandMoveTripsToUser",
    "./nodeCommandMoveDeliveryUnitToAnotherUser",
    "./monitoringNodeCommandDocumentView",
    "./nodeCommandViewArrangement",
    "./nodeCommandViewTripArrangement",
    "./nodeCommandPermissionGroupDetails",
    "./nodeCommandPermissionGroupInactivate",
    "./nodeCommandTripPickingList",
    "./nodeCommandViewTripOperationHistory",
    "./nodeCommandPermissionGroupPurge"
], function (nodeCommandsModule) {
    "use strict";

    /**
     * @ngdoc service
     * @name nodeCommandsModule.commonNodeCommandExecutor
     * @description
     * Estrutura com comandos para execução pela tela de análise.
     *
     * Comandos são serviços que recebem como parâmetro um array com os nós envolvidos na operação.
     * */
    return nodeCommandsModule.service("commonNodeCommandExecutor", [
        "NodeCommandExecutor",
        "nodeCommandViewRoute",
        "nodeCommandCalculateToll",
        "nodeCommandCancelTrips",
        "nodeCommandOptimize",
        "nodeCommandOptimizeRestrictions",
        "nodeCommandFinalizeTrip",
        "nodeCommandMoveTripsToUser",
        "nodeCommandMoveDeliveryUnitToAnotherUser",
        "monitoringNodeCommandDocumentView",
        "nodeCommandViewArrangement",
        "nodeCommandViewTripArrangement",
        "nodeCommandPermissionGroupDetails",
        "nodeCommandPermissionGroupInactivate",
        "nodeCommandTripPickingList",
        "nodeCommandViewTripOperationHistory",
        "nodeCommandPermissionGroupPurge",
        "calculateExternalFreightCommand",
        function (NodeCommandExecutor, nodeCommandViewRoute, nodeCommandCalculateToll, nodeCommandCancelTrips, nodeCommandOptimize, nodeCommandOptimizeRestrictions, nodeCommandFinalizeTrip, nodeCommandMoveTripsToUser, nodeCommandMoveDeliveryUnitToAnotherUser, monitoringNodeCommandDocumentView, nodeCommandViewArrangement, nodeCommandViewTripArrangement, nodeCommandPermissionGroupDetails, nodeCommandPermissionGroupInactivate, nodeCommandTripPickingList, nodeCommandViewTripOperationHistory, nodeCommandPermissionGroupPurge, calculateExternalFreightCommand) {
            var commandMap = {
                "viewRouteCommand": nodeCommandViewRoute,
                "calculateTollCommand": nodeCommandCalculateToll,
                "cancelTripsCommand": nodeCommandCancelTrips,
                "optimizeCommand": nodeCommandOptimize,
                "optimizeRestrictionsCommand": nodeCommandOptimizeRestrictions,
                "nodeCommandFinalizeTrip": nodeCommandFinalizeTrip,
                "moveTripsToUser": nodeCommandMoveTripsToUser,
                "nodeCommandMoveDeliveryUnitToAnotherUser": nodeCommandMoveDeliveryUnitToAnotherUser,
                "monitoringNodeCommandDocumentView": monitoringNodeCommandDocumentView,
                "viewArrangement": nodeCommandViewArrangement,
                "viewTripArrangement": nodeCommandViewTripArrangement,
                "permissionGroupDetailsCommand": nodeCommandPermissionGroupDetails,
                "permissionGroupInactivateCommand": nodeCommandPermissionGroupInactivate,
                "tripPickingListCommand": nodeCommandTripPickingList,
                "nodeCommandViewTripOperationHistory": nodeCommandViewTripOperationHistory,
                "permissionGroupPurgeCommand": nodeCommandPermissionGroupPurge,
                "calculateExternalFreightCommand": calculateExternalFreightCommand
            };
            return new NodeCommandExecutor(commandMap);
        }]);
});